<template>
    <div class="my-auto w-100 main-area" style="margin-bottom: 20px !important;" v-if="this.contacts.length>0">
        <div class="profile-detail">
            <div class="profile-detail-block">
                <div class="contact-detail">
                    <h2 class="rg-title desktop">未回答個別連絡</h2>
                    <h2 class="rg-title mobile">個別連絡の状態</h2>
                    <div class="desktop-view">
                        <table class="mt-4">
                            <thead>
                                <tr>
                                    <th style="width:220px">会社名</th>
                                    <th style="width:120px">差出人</th>
                                    <th style="width:240px">件名</th>
                                    <th style="width:160px">受信日</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="msg in contacts" :key="msg._id" @click="openContactPage(msg._id)" > 
                                    <td>{{ msg.company.name }}</td>
                                    <td>{{ msg.sender }}</td>
                                    <td>{{ msg.subject }}</td>
                                    <td>{{ formatDate(msg.sent_date) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="mobile-view">
                        <div class="d-flex justify-content-between">
                            <span>未回答個別連絡</span>
                            <span>{{ unRepliedCount }}件</span>
                        </div>
                        <div class="d-flex justify-content-between" >
                            <span>未読の個別連絡</span>
                            <span>{{ unReadCount }}件</span>
                        </div>
                        <div class="d-flex justify-content-between">
                            <span>全ての個別連絡</span>
                            <span>{{ allContactsCount }}件</span>
                        </div>
                    </div>
                    <div class="contact-button-container">  
                        <router-link to="/contact-list" class="contact-btn" >
                            個別連絡一覧を表示する
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from '@/config/api';
import moment from 'moment';
export default {
    name: 'TopContacts',
    data(){
        return {
            contacts: [],
            unRead: [],
            unReplied: [],
            allContactsCount: null
        }
    },
    computed: {
        unRepliedCount() {
            return this.unReplied.length;
        },
        unReadCount() {
            return this.unRead.length;
        },
        // allContactsCount() {
        //     return this.contacts.length;
        // }
    },
    methods: {
        formatDate(date){
            return moment(date).format("YYYY[年]MM[月]DD[日]");
        },
        openContactPage(id) {
            this.$router.push({name: 'contactDetails', params: {id}});
            // const routeUrl = this.$router.resolve({
            //     name: 'contactDetails',
            //     params: { id },
            // }).href;
            // window.open(routeUrl, '_blank');
        },
        async loadTopContacts(){
            try {
                const token = await this.$auth.getToken();
                const headers = {
                    Authorization: `Bearer ${token}`,
                };
                // console.log(Api.endpoints);
                const contacts = await this.axios({
                    method: 'get',
                    url: Api.url(Api.endpoints.topMessages),
                    headers: headers,
                });
 
                this.contacts = contacts.data.data;
                this.allContactsCount = this.contacts.length;
                this.unRead = this.contacts.filter((msg)=> msg.is_read === false);
                this.unReplied = this.contacts.filter((msg)=> msg.is_replied === false && msg.contact_type !== 'その他通知');
                let unRepliedContacts = contacts.data.data.filter((msg) => msg.is_replied === false && msg.contact_type !== 'その他通知');

                let topFiveContacts = unRepliedContacts.slice(0,5);
                this.contacts = topFiveContacts;
            } catch (err) {
                console.log(err);
            }
        }
    },
    async created(){
        await this.loadTopContacts();
    }
}
</script>

<style scoped>
a:hover{
    color: #006c6b !important;
    /* text-decoration: none; */
}
.rg-title.mobile {
    display: none;
}
.profile-detail-block {
    padding: 25px 35px;
}

.profile-detail-block table thead th {
    background: none !important;
}

h2 {
    font-size: 24px;
}
.profile-detail-block {
    background-color: #fff !important;
}
table{
    width: 100%;
    text-align: center;
    border-collapse: collapse;
}
th {
    padding: 15px;
    font-size: 20px;
}
td {
    border-bottom: 1px solid #c4c4c4;
    padding: 8px;
    text-align: center;
    color: #2F2E41;
    font-size: 18px;
}

tr {
    text-align: center;
    border-bottom: 1px solid #c4c4c4;
    cursor: pointer !important;
}

.mobile-view {
    display: none;
}

@media(max-width: 767px) {

    .rg-title.desktop {
        display: none;
    }

    .rg-title.mobile {
        display: block;
        font-weight: bold;
    }
    .rg-title {
        font-size: 16px !important;
        padding-top: 10px;
        padding-left: 5px
    }
    .mobile-view {
        display: block !important;
        padding: 10px;
    }

    /* .contact-button-container {
        padding: 10px;
        display: flex;
        justify-content: center;
    }
    .contact-btn {
        width: 90%;
        height: 40px;
        text-align: center;
        padding-top: 6px !important;
    } */
    .profile-detail-block {
        padding: 20px !important
    }
    .contact-detail {
        border: 1px solid rgba(1, 58, 61, 0.1);
        /* box-shadow: 0px 0px 20px -2px rgba(1, 58, 61, 0.1); */
    }
    .desktop-view {
        display: none !important;
    }
}
</style>